import { mapState, mapGetters, mapActions } from 'vuex';
import Tree from "./Tree";
import VueCookie from 'vue-cookie';

export default {
  components: {
    Tree,
  },

  props: {
    reportMode: {
      required: false,
      default: false
    }
  },


  data() {
    return {
      search: '',
      expandedNodes: [],
      selectedNodes: [],
    };
  },


  computed: {
    ...mapState({
      sites: state => state.user.sites,
      stateTree: state => state.charts.tree,
      selectedSources: state => state.charts.selectedSources,
      databaseName: state => state.user.databaseName,
    }),

    ...mapGetters({
      getNodeByCode: 'charts/getNodeByCode',
      getAllAvailableParameters: 'getAllAvailableParameters',
    }),

    visible() {
      return this.stateTree != null;
    },
  },

  watch: {
    // sites() {
    //   this.buildTree();
    // },

    search() {
      this.searchNodes()
    },
  },


  async mounted() {
    //Ensuring Measure Types Are Loaded Before Building Tree 
    if (this.$store.state.charts.measureTypes.length === 0) await this.loadMeasureTypes()
    //Importing Tree State From Cookie 
    this.expandedNodes = JSON.parse(VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.expandedNodes`) || '[]');
    this.selectedNodes = JSON.parse(VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.selectedNodes`) || '[]');
    //Setting Selected Sources If Not In Report Mode 
    if (!this.reportMode) {
      this.setSelectedSources(this.selectedNodes);
      this.filterSelectedSourcesForMode(this.mode === "INDICATORS" ? ["indicator"] : ["channel", "parameter"])
    }
    //Building Tree 
    if (this.sites) this.buildTree()
  },

  methods: {
    checkParameter(parameterCode) {
      return !!this.getAllAvailableParameters.find(
        (stateParameter) => stateParameter.code === parameterCode,
      );
    },

    searchNodes() {
      const search = this.search.toLowerCase().trim();
      let checkNodeForSearch = (node, search) => {
        return node.visible == 1 &&
        (node.name.toLowerCase().includes(search) || 
        node.code.toLowerCase().includes(search));
      };

      let s = (node) => {
        // Check if node should be visible based on its 'visible' field
        const isNodeHidden = (node.type === 'channel' || node.type === 'parameter' || node.type === 'indicator') && node.visible === 0;
        
        if (node.children && node.children.length > 0) {
          let results = node.children.map(s)
          if (results.includes(true)) {
            this.setVisibilityState({ node, visibility: true })
            return true
          }
        }
        if (checkNodeForSearch(node, search)) {
          // Only show node if it's not hidden
          if (!isNodeHidden) {
            this.setVisibilityState({ node, visibility: true })
            return true
          } else {
            this.setVisibilityState({ node, visibility: false })
            return false
          }
        } else {
          this.setVisibilityState({ node, visibility: false })
          return false
        }

      }
      this.stateTree.children.forEach(s)
      return;
    },

    getAllChildrenNodes(children, arr = []) {
      if (!children) {
        return [];
      }

      for (let i = 0; i < children.length; i++) {
        arr.push(children[i]);
        this.getAllChildrenNodes(children[i].children, arr);
      }

      return arr;
    },

    ...mapActions({
      loadMeasureTypes: 'charts/loadMeasureTypes',
      setVisibilityState: 'charts/setVisibilityState',
      toggleExpandState: 'charts/toggleExpandState',
      toggleSelectState: 'charts/toggleSelectState',
      setSelectedSources: 'charts/setSelectedSources',
      filterSelectedSourcesForMode: 'charts/filterSelectedSourcesForMode',
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/Charts/Tree/TreeMixin.js